import axios from "axios"

import { apiDomain } from "../../store/constants"

const Attachment = {
    uploadFile(data) {
        return axios({
            url: apiDomain + `api/upload`,
            method: 'POST',
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    downloadFile(data) {
        return axios({
            url: apiDomain + `api/download/${data}`,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
}

export default Attachment